import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import "rsuite/dist/styles/rsuite-default.css";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));
// Pages
const Login = React.lazy(() => import("./views/auth/Login"));
const Otp = React.lazy(() => import("./views/auth/Otp"));
const Register = React.lazy(() => import("./views/auth/Register"));
const Verify = React.lazy(() => import("./views/auth/Verify"));

class App extends Component {
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/otp"
              name="otp"
              render={(props) => <Otp {...props} />}
            />
            <Route
              exact
              path="/verify"
              name="Verify Account"
              render={(props) => <Verify {...props} />}
            />
            <Route
              exact
              path="/register"
              name="Register"
              render={(props) => <Register {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) => <TheLayout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
